export default "__VITE_ASSET__DRkH6zw$__"